import { DatePipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import {
  CancelCaseModel,
  CaseDetailsModel,
  CaseFollowUpModel,
} from '@app/core/models/case.model';
import { FileService } from '@app/core/services/file.service';
import { CASE_ORIGIN_CODE } from '@app/shared/app.constants';
import { AuthSelectors, CaseActions } from '@app/store';
import { AppState } from '@app/store/app.state';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { CancelCaseDialogComponent } from '../cancel-case-dialog/cancel-case-dialog.component';

@Component({
  selector: 'app-support-list-detail',
  templateUrl: './support-list-detail.component.html',
  styleUrls: ['./support-list-detail.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SupportListDetailComponent {
  @Input() caseDetails: CaseDetailsModel;
  @Input() element: FormControl<any | null>;
  @Input() caseDetailsInDialog: boolean = false;
  @Output() expandedElementEvent = new EventEmitter<any | null>();

  subscriptions: Subscription = new Subscription();
  showFollowUp: boolean = false;
  notes: FormControl<string> = new FormControl('');
  minDate = new Date('1970-01-01T00:00:00.000Z');
  notesMaxlength = 2000;
  caseOriginCode = CASE_ORIGIN_CODE;

  constructor(
    public datePipe: DatePipe,
    public fileService: FileService,
    private store: Store<AppState>,
    private dialog: MatDialog
  ) {}

  downloadFile(documentId: Blob, fileName: string) {
    this.fileService.createAndDownloadBlobFile(documentId, fileName);
  }

  setShowFollowUp(value: boolean) {
    this.showFollowUp = value;
  }

  setExpandedElement(value: any | null) {
    this.expandedElementEvent.emit(value);
  }

  addNotes(element = null) {
    this.subscriptions.add(
      this.store.select(AuthSelectors.getUser).subscribe(user => {
        if (user && element.caseNumber && this.notes.value) {
          const caseFollowUp: CaseFollowUpModel = {
            caseNumber: element.caseNumber,
            followupText: this.notes.value,
            portalUserName: user.name,
          };

          this.store.dispatch(
            CaseActions.createCaseFollowUp({ caseFollowUp: caseFollowUp })
          );

          this.notes.reset('');
        }
      })
    );
  }

  confirmCancelCase(caseDetails: CaseDetailsModel, notes: string): void {
    this.subscriptions.add(
      this.store.select(AuthSelectors.getUser).subscribe(user => {
        if (user && caseDetails.caseNumber && caseDetails.caseId) {
          this.store.dispatch(
            CaseActions.cancelingCaseId({ caseId: caseDetails.caseNumber })
          );

          let detailNotes = '';
          detailNotes += `Cancelled By ${user.idTokenClaims.name}\n`;
          detailNotes += `Email: ${user.idTokenClaims.email}\n\n`;
          detailNotes += `Cancellation Notes: ${notes}\n`;

          const cancelCaseData: CancelCaseModel = {
            caseNumber: caseDetails.caseNumber,
            caseId: caseDetails.caseId,
            status: 2,
            updateReason: detailNotes,
          };
          this.setExpandedElement(null);
          this.store.dispatch(CaseActions.cancelCase({ cancelCaseData }));
        }
      })
    );
  }

  openCancelCaseDialog(caseDetails): void {
    const dialogRef = this.dialog.open(CancelCaseDialogComponent, {
      width: '400px',
      data: { caseDetails },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.confirmCancelCase(caseDetails, result.notes);
      }
    });
  }
}
